import { nsTerminal } from '@/app/i18n/namespaces';

const TRANSACTION_TYPE = {
    DEBIT: { name: 'DEBIT', entity: 'transaction_type.DEBIT', namespace: nsTerminal, variant: 'green' },
    DEBIT_REVERSAL: { name: 'DEBIT_REVERSAL', entity: 'transaction_type.DEBIT_REVERSAL', namespace: nsTerminal, variant: 'blue' },
    CREDIT: { name: 'CREDIT', entity: 'transaction_type.CREDIT', namespace: nsTerminal, variant: 'orange' },
    TNA: { name: 'TNA', entity: 'transaction_type.TNA', namespace: nsTerminal, variant: 'red' }
};

export default TRANSACTION_TYPE;
